var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-text-field',{attrs:{"label":"Type d'adoucisseur","type":"text"},on:{"change":_vm.changedLabel},model:{value:(_vm.softener_type),callback:function ($$v) {_vm.softener_type=$$v},expression:"softener_type"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }